export default __webpack_public_path__ + "static/media/logo_tiktokads.e2640cbd.svg";